
import { UseFormReturn } from "react-hook-form";
import { FormValues } from "@/types/loan";
import { PersonalBasicInfoFields } from "./PersonalBasicInfoFields";
import { FinnishTermsCheckbox } from "./FinnishTermsCheckbox";
import { motion } from "framer-motion";
import { User } from "lucide-react";
import { useIsMobile } from "@/hooks/use-mobile";

interface PersonalInfoSectionProps {
  form: UseFormReturn<FormValues>;
  setTermsOpen: (value: boolean) => void;
  setPrivacyPolicyOpen: (value: boolean) => void;
}

export const PersonalInfoSection = ({ 
  form, 
  setTermsOpen, 
  setPrivacyPolicyOpen 
}: PersonalInfoSectionProps) => {
  const isMobile = useIsMobile();
  
  return (
    <motion.div 
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.3, delay: 0.2 }}
      className="p-4 md:p-5 bg-gradient-to-b from-blue-50 to-blue-50/60 rounded-xl border border-blue-100/80 shadow-sm"
    >
      <h2 className="text-lg font-bold text-blue-700 mb-4 flex items-center">
        <span className="inline-block w-1.5 h-6 bg-blue-500 rounded-full mr-2"></span>
        Henkilötiedot
      </h2>
      
      <div className={`space-y-4 ${isMobile ? 'md:space-y-5' : 'md:space-y-6'}`}>
        <PersonalBasicInfoFields form={form} />
        
        <FinnishTermsCheckbox 
          form={form} 
          setTermsOpen={setTermsOpen} 
          setPrivacyPolicyOpen={setPrivacyPolicyOpen} 
        />
      </div>
    </motion.div>
  );
};
